import React from "react";
import { isTrimmedStringEmpty } from "../../../Utilities/commonUtilities";
import { ExternalLink } from "../../../Components/Link";
import { HtmlDisplay } from "../../../Components/Display/HtmlDisplay";

const HTML_TAG_REGEX = /<\/?[a-zA-Z][a-zA-Z0-9]*(\s[^<>]*)?\/?>/;

export const containsHtml = (value: string): boolean => HTML_TAG_REGEX.test(value);

export const parseTextWithLinks = (text: string | number | null | undefined) => {
if (!text || typeof text !== "string") return text;

    const URL_REGEX = /(https?:\/\/[^\s[\],]+)(?:\[(.*?)\])?/g;

    const nodes = [];
    let lastIndex = 0;
    let match;
    let key = 0;

    while ((match = URL_REGEX.exec(text)) !== null) {
        const [fullMatch, url, label] = match;
        const start = match.index;

        if (start > lastIndex) {
            nodes.push(
                <span key={`text-${key++}`}>
                    {text.substring(lastIndex, start)}
                </span>
            );
        }

        nodes.push(
            <ExternalLink
                key={`link-${key++}`}
                url={url}
                label={label || url}
                hasNoIcon
            />
        );

        lastIndex = start + fullMatch.length;
    }

    if (lastIndex < text.length) {
        nodes.push(
            <span key={`text-${key++}`}>
                {text.substring(lastIndex)}
            </span>
        );
    }

    return nodes;
};

export const getAvailabilityStatus = (quantityCurrentlyAvailable: number | null, totalQuantity: number | null) => {
    const available = quantityCurrentlyAvailable || 0;
    const total = totalQuantity || 0;

    if (available === 0) {
        return <span className="badge">Unavailable</span>;
    } else {
        return <span className="badge">{available} of {total} Available</span>;
    }
};

export const renderCatalogDetail = (value: string | number | boolean | null | undefined, label: string, options: { enableLinkParsing?: boolean; showBooleanOnlyIfTrue?: boolean } = {}) => {
    const { enableLinkParsing = false, showBooleanOnlyIfTrue = false } = options;

    if (typeof value === 'boolean') {
        if (showBooleanOnlyIfTrue) {
            return value ? <div><b>{label}:</b> Yes</div> : null;
        }
        return <div><b>{label}:</b> {value ? 'Yes' : 'No'}</div>;
    }

    if (isTrimmedStringEmpty(value) && typeof value !== 'number') return null;

    if (typeof value === 'string' && containsHtml(value)) {
        return (
            <div>
                <b>{label}:</b>{' '}
                <HtmlDisplay html={value} isInline className="catalog-detail__html" />
            </div>
        );
    }

    const displayValue = enableLinkParsing ? parseTextWithLinks(value) : value;
    return <div><b>{label}:</b> {displayValue}</div>;
};
